import { Modal, Spin, notification } from 'antd';
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';
import * as dashboardService from '../../../../../services/Dashboard';
import { AvailabilityDetails } from '../../shared/constants/availabilityconstants';
import { CodeConstant } from '../../../../../constants';
import { pushLog2DV2LogServer } from '../../../../../services/logging';
import { getAvailabilityId, AVAILABILITY_STATUS_NAMES } from '../../../../../constants/AvailabilityType';
import '../Profile.css';
import styles from './availabilityv3.modal.module.scss';
import AvailabilityDuration from '../../shared/AvailabilityCard/AvailabilityDuration';
import AvailabilityQuestionCard from '../../shared/AvailabilityCard/AvailabilityQuestionCard';
import JobTypeTag from '../../shared/AvailabilityCard/JobTypeTag';
import SectionTitle from '../../shared/SectionTitle/RenderSectionTitle';

const AvailabilityModalV3 = (props) => {
  const {
    availability,
    loadData
  } = props;

  const [availability_status, setAvailabilityStatus] = useState(null);
  const [availability_type, setAvailabilityType] = useState(null);
  const [current_status, setCurrentStatus] = useState(null);
  const [start_time, setStartTime] = useState(null);
  const [devAvailabilityStatuses, setDeveloperAvailabilityStatus] = useState({});
  const [showNoticeQuestions, setShowNoticeQuestion] = useState(true);
  const [loading, setLoading] = useState(false);
  const initializeData = () => {
    if (!loadData && availability && availability.last_update) { /* CRASH BUG QUICK FIX */
      /* REPEATED CODE EVERYWHERE */
      const dateDiffe = moment(moment(availability.last_update).add(29, 'days')).diff(moment(), 'days');
      getDeveloperAvailabilityStatuses();

      setCurrentStatus(availability.current_status);

      if (availability.availability_answer && (availability.availability_answer.toLowerCase() === AVAILABILITY_STATUS_NAMES.UNKNOWN || dateDiffe <= 0)) {
        /* EXPIRED STATUS, DO NOT PRE-FILL VALUES */
      } else {
        setAvailabilityStatus(dateDiffe >= 15 ? (availability.availability_answer || null) : null);
        if (dateDiffe >= 15) {
          if (availability.availability_answer && availability.availability_answer.toLowerCase() === AVAILABILITY_STATUS_NAMES.NOT_LOOKING_FOR_JOB) setShowNoticeQuestion(false);
          else setShowNoticeQuestion(true);
        }
        setAvailabilityType(dateDiffe >= 15 ? (availability.availability_status_id || null) : null);
        setStartTime(dateDiffe >= 15 ? availability.starts_in_weeks : null);
      }

      setLoading(false);
    } else {
      setLoading(true);
      Promise.all([getDeveloperAvailabilityStatuses(), setUserAvailability()]).then((res) => {
        setLoading(false);
      }).catch((e) => {
        console.log(e);
        setLoading(false);
      });
    }
  };

  const getDeveloperAvailabilityStatuses = async () => {
    try {
      if (!loadData) setLoading(true);
      const response = await dashboardService.getDeveloperAvailabilityStatuses();
      if (response.status === CodeConstant.OK) {
        const developerAvailabilityStatuses = {};
        response.data.sort((a, b) => {
          if (a.status.toUpperCase() < b.status.toUpperCase()) return -1;
          if (a.status.toUpperCase() > b.status.toUpperCase()) return 1;
          else return 0;
        });
        response.data.forEach((item) => { developerAvailabilityStatuses[item.status.toUpperCase().replace(' ', '_')] = item; });
        setDeveloperAvailabilityStatus(developerAvailabilityStatuses);
      }
      if (!loadData) setLoading(false);
    } catch (e) {
      console.log(e);
      setDeveloperAvailabilityStatus({});
      if (!loadData) setLoading(false);
    }
  };

  const setUserAvailability = async () => {
    try {
      const response = await dashboardService.getUserAvailabilityV2();

      if (response.status === CodeConstant.OK) {
        const availability = response.data.data;
        if (availability) {
          availability.availability_status_id = getAvailabilityId(availability.developer_availability_type);

          /* CRASH BUG QUICK FIX */
          let dateDiffe = 30; /* DEFAULT: IF THERE IS NO VALUE -> ERROR -> SHOULD SHOW NOT AVAILABLE -> SET THE DATE DIFF > 30 */
          if (availability.last_update) dateDiffe = moment(moment(availability.last_update).add(29, 'days')).diff(moment(), 'days');
          if (dateDiffe >= 15) {
            if (availability.availability_answer && availability.availability_answer.toLowerCase() === AVAILABILITY_STATUS_NAMES.NOT_LOOKING_FOR_JOB) setShowNoticeQuestion(false);
            else setShowNoticeQuestion(true);
          }

          setCurrentStatus(availability.current_status);

          if (availability.availability_answer && (availability.availability_answer.toLowerCase() === AVAILABILITY_STATUS_NAMES.UNKNOWN || dateDiffe <= 0)) {
            /* EXPIRED STATUS, DO NOT PRE-FILL VALUES */
          } else {
            setAvailabilityStatus(dateDiffe >= 15 ? (availability.availability_answer || null) : null);
            if (dateDiffe >= 15) {
              if (availability.availability_answer && availability.availability_answer.toLowerCase() === AVAILABILITY_STATUS_NAMES.NOT_LOOKING_FOR_JOB) setShowNoticeQuestion(false);
              else setShowNoticeQuestion(true);
            }
            setAvailabilityType(dateDiffe >= 15 ? (availability.availability_status_id || null) : null);
            setStartTime(dateDiffe >= 15 ? availability.starts_in_weeks : null);
          }
        }
      }
    } catch (e) {
      console.log(e);
      this.props.handleUserIsAvailableChange(undefined);
    }
  };

  useEffect(() => {
    initializeData();
  }, [/* availability, loadData, availability && availability.availability_status_id, availability && availability.starts_in_weeks */]);

  const handleAvailabiltityChange = (answer) => {
    setAvailabilityStatus(answer);
    if (answer.toLowerCase() === AVAILABILITY_STATUS_NAMES.NOT_LOOKING_FOR_JOB) setShowNoticeQuestion(false);
    else setShowNoticeQuestion(true);
  };

  const getAvailabilityObject = (answer = availability_status) => {
    const availabilityObj = AvailabilityDetails.filter((item) => item.value.toLowerCase() === answer.toLowerCase());
    if (availabilityObj && availabilityObj.length > 0) {
      availabilityObj[0].last_update = moment().format('YYYY-MM-DD HH:mm:ss');
    }
    return availabilityObj;
  };

  const getCurrentStatus = (statId) => {
    let current_status = null;
    Object.keys(devAvailabilityStatuses).forEach((item) => {
      if (devAvailabilityStatuses[item] && devAvailabilityStatuses[item].id) {
        if (parseFloat(devAvailabilityStatuses[item].id) === parseFloat(statId)) {
          current_status = item.replace('_', ' ');
        }
      }
    });
    return current_status;
  };

  const closeAvailabilityModal = useCallback(() => {
    localStorage.setItem('availability_modal_closed', 'true');
    if (props.closeAvailabilityModal) props.closeAvailabilityModal();
  }, [])

  const onOkay = async () => {
    if ((availability_status && (start_time || start_time === 0)) || !showNoticeQuestions) {
      const userAvailability = availability_status.toLowerCase() !== AVAILABILITY_STATUS_NAMES.NOT_LOOKING_FOR_JOB;
      const data = {
        answer: availability_status,
        availabilityStatusId: availability_type,
        startsInWeeks: ((!start_time && start_time !== 0) || start_time === -1 || !showNoticeQuestions) ? null : Number(start_time)
      };
      await dashboardService.saveDeveloperAvailability(data).then((res) => {
        const availabilityObj = getAvailabilityObject();
        const current_status = getCurrentStatus(availability_type);
        availabilityObj[0].current_status = current_status;
        availabilityObj[0].availability_status_id = data.availabilityStatusId;
        availabilityObj[0].starts_in_weeks = data.startsInWeeks;
        availabilityObj[0].availability_answer = availability_status;
        if (props.handleUserIsAvailableChange) {
          props.handleUserIsAvailableChange(userAvailability, availabilityObj[0] || {}, true);
        }

        pushLog2DV2LogServer.info('USER_AVAILABILITY', 'USER_CONFIRM_AVAILABILITY', {}, { availability_status, ...data }, {});
        notification.success({ message: 'Availability saved successfully' });
      }).catch((e) => {
        console.log(e);
        const { errorCode, message, stack } = e;
        pushLog2DV2LogServer.error('USER_AVAILABILITY', 'USER_CONFIRM_AVAILABILITY', {}, { availability_status, ...data }, { errorCode, message, stack });
        notification.error({ message: 'Error: Availability not saved' });
      });
    }
    closeAvailabilityModal();
  };

  const disabledBtn = showNoticeQuestions && (!availability_status || !availability_type || availability_type === 1 || ((!start_time || start_time < 0) && start_time !== 0));

  return (
    <Modal
      className={classnames("turing-ui-v2-modal", "custom-availability-modal", styles.availabilityModal)}
      title="Work Availability Update"
      okText="Update and continue"
      onOk={onOkay}
      width={900}
      visible={true}
      {...props}
      okButtonProps={{ disabled: disabledBtn }}
      onCancel={closeAvailabilityModal}
    >
      <Spin spinning={loading} />
      <div className="pretest-english-proficiency">
        <AvailabilityQuestionCard value={availability_status || null} handleChange={handleAvailabiltityChange} />
      </div>
      <div className="new-availability-spacing" />
      {
        showNoticeQuestions ? (
          <div className={classnames(styles.questionWrapper)}>
            <div className={classnames(styles.question)}>
              <SectionTitle title="Are you interested in full-time work (8hrs/day, 40hrs/week)?" />
              <JobTypeTag
                current_status={current_status}
                handleAvailabilityTypeChange={(value) => setAvailabilityType(value)}
                availabilityStatus={devAvailabilityStatuses}
                checked={!availability_type ? undefined : availability_type}
              />
            </div>
            <div className={classnames(styles.question)}>
              <SectionTitle title="What’s your notice period for resigning from your current job and starting full-time with Turing?" />
              <AvailabilityDuration
                handleChange={(value) => setStartTime(value < 0 ? 5 : value)}
                checked={start_time < 0 ? undefined : start_time}
              />
            </div>
          </div>
        ) : null
      }
    </Modal>
  );
};

AvailabilityModalV3.propTypes = {
  availability: PropTypes.object,
  loadData: PropTypes.bool,
  closeAvailabilityModal: PropTypes.func,
  handleUserIsAvailableChange: PropTypes.func
};

export default AvailabilityModalV3;
